import { createFileRoute, useNavigate } from "@tanstack/react-router";
import type { ShopOrderStatus } from "../api/shop.ts";
import { HqOrdersPage } from "../components/shop/hq-orders-page.tsx";

const STATUSES = [
  "submitted",
  "approved",
  "partially_shipped",
  "rejected",
  "shipped",
  "cancelled",
  "delivered",
] as const;

interface Search {
  readonly status?: ShopOrderStatus | "alla";
}

export const Route = createFileRoute("/bestallningar/")({
  component: Screen,
  validateSearch: (search: Record<string, unknown>): Search =>
    search.status === "alla" || STATUSES.includes(search.status as ShopOrderStatus)
      ? { status: search.status as ShopOrderStatus | "alla" }
      : {},
});

function Screen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const status = search.status === "alla" ? null : (search.status ?? "submitted");

  return (
    <HqOrdersPage
      status={status}
      onStatusChange={(next) =>
        void navigate({
          search: next === "submitted" ? {} : { status: next ?? "alla" },
          replace: true,
        })
      }
    />
  );
}
